import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/** Keeps already signed-in users out of the login page. */
export const loginGuard: CanActivateFn = async (route) => {
  const platformId = inject(PLATFORM_ID);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (isPlatformServer(platformId)) {
    return true;
  }

  const signedIn = await authService.whenResolved();
  if (!signedIn) {
    return true;
  }

  const pathname = route.queryParamMap.get('pathname');
  const isDirectEmailLink = route.queryParamMap.get('mode') === 'signIn';
  if (authService.emailLinkReturnPath && (isDirectEmailLink || pathname === authService.emailLinkReturnPath)) {
    return router.parseUrl(authService.emailLinkReturnPath);
  }
  return router.createUrlTree(['/']);
};
